import { jsx as c } from "react/jsx-runtime";
import { SvgIcon as r } from "../SvgIcon.js";
const m = (o) => /* @__PURE__ */ c(r, { ...o, children: /* @__PURE__ */ c("path", { d: "M2.17557 17.8465c.65157.6515 1.70072.6515 2.35229 0l.69575-.6958 6.70349-6.7035c1.6676.7289 3.6886.4087 5.058-.96074 1.3804-1.36941 1.7007-3.40144.9608-5.08007l-2.7278 2.71673c-.6516.65157-1.7007.65157-2.3523 0s-.6516-1.70072 0-2.3523l2.7278-2.72777c-1.6787-.72887-3.7107-.40861-5.0801.96079-1.38045 1.38046-1.70071 3.42353-.94975 5.10217L2.87132 14.8095l-.69575.6957c-.65157.6516-.65157 1.7007 0 2.3413Z" }) });
export {
  m as Tune
};
//# sourceMappingURL=Tune.js.map
